/*
 * We use a .cjs (CommonJS) file so variables can be imported by next.config.js (Node.js)
 * without causing errors related to ES module syntax or TypeScript compilation.
 */
const DEVICE_SIZES = [640, 768, 1024, 1280, 1536]

// Use CommonJS export
module.exports = { DEVICE_SIZES }
